<template>
  <div class>
    <!-- header start -->
    <van-nav-bar
      title="生平简介"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div class="life-section">
      <van-tabs animated color="#24a378" type="card" swipeable>
        <van-tab
          :title="item.DeceasedName"
          v-for="(item, index) in apiModelList"
          :key="item.id"
        >
          <div class="life-content">
            <div class="text-center">
              <van-image
                round
                width="100px"
                height="100px"
                fit="cover"
                v-bind:src="item.HeadPhoto"
              />
            </div>
            <p v-if="currentToken.isLogin && data.IsSelf" class="text-center">
              <router-link
                :to="{ path: '/LifeEdit', query: { id: id, index: index } }"
                class="hlight t14"
                >编辑</router-link
              >
            </p>
            <div class="info-box">
              <p>姓名: {{ item.DeceasedName }}</p>
              <p>性别: {{ item.Sex }}</p>
              <p>籍贯: {{ item.OriginalhomeAddress }}</p>
              <p>生辰: {{ item.OutPutBirthdayDateDesc }}</p>
              <p>忌日: {{ item.OutPutPassAwayDateDesc }}</p>
              <p>生肖: {{ item.Zodiac }}</p>
              <!-- <p>职业:歌手</p>
    	  			<p>信仰:共产主义</p>
    	  			<p>生活地址:北京</p>
              <p>墓地地址:武汉石门峰名人纪念公园</p>-->
              <p>天堂编号: TT{{ id }}</p>
            </div>
            <div class="description">
              <p class="t14 c8">简介:</p>
              <!-- <div class="des">姚贝娜，英文名Bella，1981 年9月26日出生于湖北省武汉市，毕业于中国音乐学院声歌系，中国流行女歌手、青年歌唱家、中国文艺志愿者协会原理事、中国人民解放军海军政治部歌舞团原独唱演员(2009年退伍)
              </div>-->
              <div class="des" v-html="item.LifeIntroduction"></div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import auth from "../../../tools/auth";

export default {
  data() {
    return {
      data: [],
      memorialHallapiModel: [],
      apiModelList: [],
      id: 0,
    };
  },
  components: {},
  computed: {
    ...mapGetters(["currentToken"]),
  },
  methods: {
    onClickLeft() {
      //this.$router.go(-1);
      this.$back();
    },
    init() {
      var that = this;
      that.$store
        .dispatch({
          type: "GetMemorialHallSearchApiById",
          id: that.id,
        })
        .then(
          (res) => {
            that.data = res;
            that.memorialHallapiModel = res.MemorialHallSearchApiModel;
            if (that.memorialHallapiModel.IsPrivacy) {
              var _id = that.memorialHallapiModel.SerialNumber;
              auth.IsFriend(this, _id);
            }
            that.apiModelList =
              that.data.MemorialHallSearchApiModel.DeceasedInformationApiModelList;
          },
          (err) => {}
        );
    },
  },
  activated() {
    var that = this;
    that.id = this.$route.query.id;
    that.init();
  },
  created() {
    // var that = this;
    // that.id = this.$route.query.id;
    // that.init();
  },
};
</script>

<style scoped>
.life-section {
  margin-top: 15px;
}
.life-content {
  padding: 15px 40px;
}
.info-box {
  margin-top: 15px;
}
.info-box p {
  font-size: 15px;
  line-height: 1.7;
  color: #444;
}
.description {
  margin-top: 15px;
  padding-bottom: 20px;
}
.description .des {
  margin-top: 4px;
  font-size: 14px;
  line-height: 1.4;
  color: #444;
}
.description .des img {
  text-align: center;
  max-width: 100%;
}
</style>
